var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvangeLogDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51562 0.415039C4.10031 0.415039 0.515625 3.99972 0.515625 8.41504C0.515625 12.8304 4.10031 16.415 8.51562 16.415C12.9309 16.415 16.5156 12.8304 16.5156 8.41504C16.5156 3.99972 12.9309 0.415039 8.51562 0.415039ZM6.38229 7.88171H4.78229C4.57295 7.88171 4.38363 8.00371 4.29628 8.19503C4.20962 8.3857 4.24295 8.60904 4.38028 8.76704L8.11362 13.0337C8.21495 13.1497 8.36161 13.2157 8.51496 13.2157C8.66829 13.2157 8.81496 13.1497 8.9163 13.0337L12.6496 8.76704C12.787 8.60904 12.8203 8.3857 12.7336 8.19503C12.647 8.00436 12.457 7.88171 12.2476 7.88171H10.6476V4.14837C10.6476 3.8537 10.409 3.61504 10.1143 3.61504H6.91429C6.61962 3.61504 6.38096 3.8537 6.38096 4.14837V7.88171H6.38229Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvangeLogDownload);
export default __webpack_public_path__ + "static/media/advange-log-download.4d9070d039d449ed08abfce86e23341b.svg";
export { ForwardRef as ReactComponent };